import React from "react";
import { History } from "history";
import { PlanoVinculadoEntidade, ContratoEntidade, ContratoDisponivel, ParametrosSimulacao, PrestacaoEntidade } from "../../../../entidades";
import { Page } from "../../..";
import { NumFuncionalidade } from "../../../Page";
import { Box, CampoEstatico, TipoCampoEstatico, Row, Col, Botao, TipoBotao, TipoAlerta, Alerta, BotaoSwitch } from "@intechprev/componentes-web";
import { EmprestimoService, PlanoService } from "../../../../services";
import { decimalFix } from "../../../../_utils/decimalFix";
import { Link } from "react-router-dom";

interface IProps {
  history?: History;
}

interface IState {
  plano: PlanoVinculadoEntidade;
  emprestimos: Array<ContratoEntidade>;
  valorSolicitado: number;
  valorMargemConsignavel: number;
  saldoContratosAtivos: number;
  contrato: ContratoDisponivel;
  leuTermoAssinado: boolean;
  leuContratoAbertura: boolean;
  linkTermosEmprestimo: string;

  erro: string;
}

export class EmprestimoSimuladorResumo extends React.Component<IProps, IState> {

  private page = React.createRef<Page>();

  constructor(props: IProps) {
    super(props);

    const dados: ParametrosSimulacao = JSON.parse(localStorage.getItem("emprestimo-parametros"));
    const contrato: ContratoDisponivel = JSON.parse(localStorage.getItem("emprestimo-contrato-selecionado"));

    var recursoUtilizado = 0;

    if (dados.emprestimos.length > 0) {
      recursoUtilizado = dados.emprestimos.map(x => x.SaldoDevedor.ValorReformado).reduce((x, y) => x + y);
    }

    this.state = {
      plano: new PlanoVinculadoEntidade(),
      emprestimos: dados.emprestimos,
      valorSolicitado: dados.valorSolicitado,
      valorMargemConsignavel: dados.ValorMargem,
      saldoContratosAtivos: recursoUtilizado,
      contrato,
      leuTermoAssinado: false,
      leuContratoAbertura: false,
      linkTermosEmprestimo: "",

      erro: null,
    };
  }

  componentDidMount = async () => {
    await this.page.current.loading(true);
    try {
      const dados: ParametrosSimulacao = JSON.parse(localStorage.getItem("emprestimo-parametros"));

      const plano = await PlanoService.Buscar();

      const linkTermosEmprestimo = await EmprestimoService.BuscarLinkDocumentosEmprestimo();

      this.setState({
        plano: plano.filter(x => x.CD_PLANO === dados.CdPlano)[0],
        linkTermosEmprestimo: linkTermosEmprestimo
      });
    } catch (err) {
      const error: any = err;
      this.setState({
        erro: error.response ? error.response.data : error,
      });
    }
    finally {
      await this.page.current.loading(false);
    }
  };

  render() {
    return (
      <Page {...this.props} Funcionalidade={NumFuncionalidade.EMPRESTIMOS_SIMULAÇÃO} ref={this.page}>
        <h3>Bem-Vindo ao Simulador de Empréstimos da São Francisco!</h3>
        {/* <h5>Ao final da sua simulação você poderá realizar o requerimento do seu empréstimo diretamente por aqui, de forma on-line e segura!</h5> */}

        <Row>
          <Col>
            <Box titulo={"Resumo dos Cálculos"}>
              <CampoEstatico
                titulo={"Plano"}
                valor={this.state.plano.DS_PLANO}
                tamanhoTitulo={"md-4"}
              />

              <CampoEstatico
                titulo={"Modalidade do Empréstimo"}
                valor={this.state.contrato.Modalidade.DS_MODAL}
                tamanhoTitulo={"md-4"}
              />

              <CampoEstatico
                titulo={"Saldo Devedor"}
                valor={this.state.saldoContratosAtivos}
                tipo={TipoCampoEstatico.dinheiro}
                tamanhoTitulo={"md-4"}
              />

              <CampoEstatico
                titulo={"Valor Solicitado"}
                valor={this.state.contrato.ValorSolicitado}
                tipo={TipoCampoEstatico.dinheiro}
                tamanhoTitulo={"md-4"}
              />

              <CampoEstatico
                titulo={"Total de Encargos/Tributos*"}
                valor={this.state.contrato.ValorTaxaAdministracao + this.state.contrato.ValorTaxaSeguro + this.state.contrato.ValorIOF}
                tipo={TipoCampoEstatico.dinheiro}
                tamanhoTitulo={"md-4"}
              />

              <b>
                <CampoEstatico
                  titulo={"Valor Líquido"}
                  valor={this.state.contrato.ValorLiquido}
                  tipo={TipoCampoEstatico.dinheiro}
                  tamanhoTitulo={"md-4"}
                />
              </b>

              <b>
                <CampoEstatico
                  titulo={"Custo Efetivo Total Anual (CET Anual)"}
                  valor={this.state.contrato.ValorCustoEfetivoTotalAnual}
                  tipo={TipoCampoEstatico.percentual}
                  tamanhoTitulo={"md-4"}
                />
              </b>

              <b>
                <CampoEstatico
                  titulo={"Custo Efetivo Total Mensal (CET Mensal)"}
                  valor={this.state.contrato.ValorCustoEfetivoTotalMensal}
                  tipo={TipoCampoEstatico.percentual}
                  tamanhoTitulo={"md-4"}
                />
              </b>

              <CampoEstatico
                titulo={"Data de Crédito"}
                valor={this.state.contrato.DataCredito}
                tamanhoTitulo={"md-4"}
              />

              <h4 className={"mt-5"}>Resumo dos Cálculos</h4>

              <CampoEstatico
                titulo={"Prazo"}
                valor={`${this.state.contrato.Prazo} Meses`}
                tamanhoTitulo={"md-4"}
              />

              <CampoEstatico
                titulo={"Taxa"}
                valor={this.state.contrato.TaxaJuros}
                tipo={TipoCampoEstatico.percentual}
                tamanhoTitulo={"md-4"}
              />

              <CampoEstatico
                titulo={"Prestações"}
                valor={this.state.contrato.ValorPrestacao}
                tipo={TipoCampoEstatico.dinheiro}
                tamanhoTitulo={"md-4"}
              />
            </Box>
          </Col>

          <Col>
            <Box titulo={"* Encargos/Tributos Calculados"}>
              <table className={"table table-sm"}>
                <thead>
                  <tr>
                    <th>Encargo/Tributo</th>
                    <th className={"text-right"}>% dos Encargos</th>
                    <th className={"text-right"}>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>TAXA DE ADMINISTRAÇÃO</td>
                    <td className={"text-right"}>
                      <CampoEstatico valor={this.state.contrato.TaxaEncargo.TX_ADM} tipo={TipoCampoEstatico.percentual} />
                    </td>
                    <td className={"text-right"}>
                      <CampoEstatico valor={this.state.contrato.ValorTaxaAdministracao} tipo={TipoCampoEstatico.dinheiro} />
                    </td>
                  </tr>
                  <tr>
                    <td>TAXA SEGURO EMPRÉSTIMO</td>
                    <td className={"text-right"}>
                      <CampoEstatico valor={this.state.contrato.TaxaEncargo.TX_SEGURO} tipo={TipoCampoEstatico.percentual} />
                    </td>
                    <td className={"text-right"}>
                      <CampoEstatico valor={this.state.contrato.ValorTaxaSeguro} tipo={TipoCampoEstatico.dinheiro} />
                    </td>
                  </tr>
                  <tr>
                    <td>IOF</td>
                    <td className={"text-right"}>
                      <CampoEstatico valor={decimalFix(this.state.contrato.TaxaEncargo.TX_IOF, 4, 4, "percent")} />
                    </td>
                    <td className={"text-right"}>
                      <CampoEstatico valor={this.state.contrato.ValorIOF} tipo={TipoCampoEstatico.dinheiro} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </Box>

            <Box titulo={"Evolução das Prestações Tabela PRICE"}>
              {this.state.contrato.Prestacoes.length > 0 && <>
                <table className={"table table-striped table-sm"}>
                  <thead>
                    <tr>
                      <th>Nº</th>
                      <th>Vencimento</th>
                      <th>Principal</th>
                      <th>Juros</th>
                      <th>Prestação</th>
                      <th>Saldo Anterior</th>
                      <th>Saldo Devedor</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.contrato.Prestacoes.map((prestacao: PrestacaoEntidade, index: number) => {
                      if (prestacao.TIPO === "P") {
                        return (
                          <tr key={index}>
                            <td>{prestacao.PARCELA}</td>
                            <td>{prestacao.DT_VENC}</td>
                            <td>
                              <CampoEstatico
                                valor={prestacao.VL_PRINCIPAL}
                                tipo={TipoCampoEstatico.dinheiro}
                              />
                            </td>
                            <td>
                              <CampoEstatico
                                valor={prestacao.VL_JUROS}
                                tipo={TipoCampoEstatico.dinheiro}
                              />
                            </td>
                            <td>
                              <CampoEstatico
                                valor={prestacao.VL_PRESTACAO}
                                tipo={TipoCampoEstatico.dinheiro}
                              />
                            </td>
                            <td>
                              <CampoEstatico
                                valor={prestacao.VL_SALDO_ANT}
                                tipo={TipoCampoEstatico.dinheiro}
                              />
                            </td>
                            <td>
                              <CampoEstatico
                                valor={prestacao.VL_SALDO_ATUAL}
                                tipo={TipoCampoEstatico.dinheiro}
                              />
                            </td>
                          </tr>
                        );
                      } else if (prestacao.TIPO === "S") {
                        return (
                          <tr key={index}>
                            <td></td>
                            <td>{prestacao.DT_VENC}</td>
                            <td colSpan={4}>Suspensa</td>
                          </tr>
                        );
                      } else {
                        return (
                          <tr key={index}>
                            <td colSpan={6}></td>
                          </tr>
                        );
                      }
                    })}
                  </tbody>
                </table>
              </>}

              {this.state.contrato.Prestacoes.length === 0 && <Alerta tipo={TipoAlerta.danger} mensagem={"Nenhum dado de prestações disponível no momento"} />}
            </Box>
          </Col>
        </Row>

        <Row>
          <Col>
            <Box>
              <div className={`alert alert-${this.state.leuTermoAssinado ? "info" : "warning"}`}>
                <Row className={"mb-2"}>
                  <Col className={"col-1 align-self-center"}>
                    <BotaoSwitch
                      tipoAtivo={TipoBotao.success}
                      iconeInativo={"fas fa-square-full"}
                      checked={this.state.leuTermoAssinado}
                      onChange={() => this.setState({ leuTermoAssinado: !this.state.leuTermoAssinado })}
                    />
                  </Col>

                  <Col className={"align-self-center"}>
                    {"Declaro que li e concordo com as informações dispostas na Política de Crédito para Concessão de Empréstimos."}
                    <br />
                    <Link to={this.state.linkTermosEmprestimo} className={"btn btn-link btn-sm"} target={"_blank"} rel={"noreferrer"}>
                      {"Clique aqui para acessar a Política de Crédito para Concessão de Empréstimos."}
                    </Link>
                  </Col>
                </Row>
              </div>

              <div className={`alert alert-${this.state.leuContratoAbertura ? "info" : "warning"}`}>
                <Row className={"mb-2"}>
                  <Col className={"col-1 align-self-center"}>
                    <BotaoSwitch
                      tipoAtivo={TipoBotao.success}
                      iconeInativo={"fas fa-square-full"}
                      checked={this.state.leuContratoAbertura}
                      onChange={() => this.setState({ leuContratoAbertura: !this.state.leuContratoAbertura })}
                    />
                  </Col>

                  <Col className={"align-self-center"}>
                    {"Declaro que li e concordo com as informações dispostas no Contrato de Abertura de Crédito de empréstimo."}
                    <br />
                    <Link to={this.state.linkTermosEmprestimo} className={"btn btn-link btn-sm"} target={"_blank"} rel={"noreferrer"}>
                      {"Clique aqui para acessar o Contrato de Abertura de Crédito de empréstimo."}
                    </Link>
                  </Col>
                </Row>
              </div>

              <div className={"mt-5"}>
                <Botao titulo={"Voltar"}
                  tipo={TipoBotao.light}
                  onClick={() => this.props.history.goBack()}
                  icone={"fas fa-chevron-left"}
                />

                <Botao
                  titulo={"Gostei! Quero Solicitar esse Empréstimo!"}
                  className={"ml-2"}
                  onClick={() => this.props.history.push("/emprestimo/simuladorcontratacao")}
                  icone={"fas fa-chevron-right"}
                  iconeDireita
                  desativado={!this.state.leuContratoAbertura || !this.state.leuTermoAssinado}
                  submit
                />
              </div>
            </Box>
          </Col>
        </Row>
      </Page>
    );
  }
}
